import React from "react";
import Svg, { Circle, Path, SvgProps } from "react-native-svg";

const ClockIcon = (props: SvgProps) => {
  return (
    <Svg width="48" height="48" fill="none">
      <Circle cx="24" cy="24" r="24" fill="#FFF3C2" />
      <Path
        fill="#8C6500"
        d="M24 14.25A9.75 9.75 0 1 0 33.75 24 9.76 9.76 0 0 0 24 14.25Zm5.25 10.5H24a.75.75 0 0 1-.75-.75v-5.25a.75.75 0 1 1 1.5 0v4.5h4.5a.75.75 0 1 1 0 1.5Z"
      />
    </Svg>
  );
};

export default ClockIcon;
